import React from 'react';
import { SectionTitle, SectionSubTitle } from '../../components/text/Titles';
import { SectionRow } from '../../components/Section';
import { Col, Switch } from 'antd';

type Props = {
  showShortcuts: boolean;
  setShowShortcuts: any;
};

export const AnnotationSettings = ({ showShortcuts, setShowShortcuts }: Props) => {
  return (
    <>
      <SectionTitle fontSize={20}>Annotation Settings</SectionTitle>
      <SectionRow className="items-center">
        <Col span={10}>
          <SectionSubTitle>Show shortcuts</SectionSubTitle>
        </Col>
        <Col span={12}>
          <Switch onChange={setShowShortcuts} checked={showShortcuts} />
        </Col>
      </SectionRow>
    </>
  );
};
